'use strict';

/**
 * Collection for catalogs
 *
 * @category   Collection
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var CatalogModel = require('../models/catalog');

var CatalogsCollection = Collection.extend({
    api: '/catalogs',

    name: 'collection:catalogs',

    model: CatalogModel,

    activeCatalog: null,

    initialize: function(models, options) {
        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));
    },

    getActiveCatalog: function() {
        return this.activeCatalog || this.at(0);
    },

    setActiveCatalog: function(id) {
        var newActiveCatalog = this.get(id) || this.at(0);

        if (newActiveCatalog !== this.activeCatalog) {
            this.activeCatalog = newActiveCatalog;
            this.trigger('change');
            this.trigger('change:activeCatalog', newActiveCatalog);
        }
    },
});

module.exports = CatalogsCollection;